export default "__VITE_ASSET__193fd3b4__"